<script lang="ts" setup>
import {
  GetPersonDocument,
  type Person,
} from '~/utils/generated/graphql'
import { getItemImageUrl } from '~/utils/graphql/graphql'
import { useGraphQuery } from '~/utils/graphql/client'

const route = useRoute()

const paging = usePaging(12)
const { locale } = useI18n()
const { data, status, error, refresh } = await useGraphQuery(GetPersonDocument, { slug: route.params.slug, locale: locale, offset: paging.offset, limit: paging.pageSize })
const person = computed(() => data.value?.contentItem as Person | null | undefined)
const pageTitle = computed(() => person.value?.title || '')
const pageDescription = computed(() => person.value?.description)

useHead({
  title: person.value?.title,
})

useSeoMeta({
  title: pageTitle,
  ogTitle: pageTitle,
  description: pageDescription,
  ogDescription: pageDescription,
  ogImage: computed(() => getItemImageUrl(person.value)),
  ogUrl: 'https://passionequip.com/people/' + route.params.slug,
})
</script>

<template>
  <PageContent
    v-if="person"
  >
    <section class="grid grid-cols-1 ps-4 pe-4 m-auto justify-items-center items-center">
      <ContentImage
        :item="person"
        class="rounded-full w-56 h-56 object-cover"
      />
      <h1 class="h1">
        {{ person.title }}
      </h1>
      <p class="p-md mb-16 text-center max-w-[590px]">
        {{ person.description }}
      </p>
    </section>
    <CollectionsGridItems
      v-if="data?.contentItems"
      :has-more="data.contentItems?.items.length < data.contentItems?.total"
      :load-more="() => { paging.pageSize.value += 12 }"
      :loading="status === 'pending'"
      :items="data.contentItems || { items: [], total: 0 }"
      :paging="paging"
    />
    <div v-else>
      No Items
    </div>
  </PageContent>
  <ContentError
    v-else-if="error"
    :refresh="refresh"
  />
</template>
